import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import { Barcode, BarcodePicker as ScanditSDKBarcodePicker, configure, CameraAccess } from "scandit-sdk";
import { Barcode, BarcodePicker as ScanditSDKBarcodePicker, configure } from 'scandit-sdk';
// let camera;
// const start = Date.now();
const style = {
  position: 'absolute',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
  margin: 'auto',
  maxWidth: '100%',
  maxHeight: '100%',
  width: 700,
};

class BarcodePicker extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    playSoundOnScan: PropTypes.bool,
    vibrateOnScan: PropTypes.bool,
    scanningPaused: PropTypes.bool,
    guiStyle: PropTypes.string,
    videoFit: PropTypes.string,
    scanSettings: PropTypes.object,
    enableCameraSwitcher: PropTypes.bool,
    enableTorchToggle: PropTypes.bool,
    enableTapToFocus: PropTypes.bool,
    enablePinchToZoom: PropTypes.bool,
    accessCamera: PropTypes.bool,
    camera: PropTypes.object,
    cameraSettings: PropTypes.object,
    targetScanningFPS: PropTypes.number,
    // cameraType: PropTypes.string,
    onScan: PropTypes.func,
    onError: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }


  componentDidMount() {
    // Configure the library and activate it with a license key

    const key = process.env.REACT_APP_SCANDIT_KEY;
    configure(key,
      {
        engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x'
      }).catch((error) => {
   
    }).then(() => {
      ScanditSDKBarcodePicker.create(this.ref.current, this.props).then((barcodePicker) => {
        this.barcodePicker = barcodePicker;
        // if (this.props.camera == undefined) {
        //   CameraAccess.getCameras().then(function (cameras) {
        //     camera = cameras.find(camera => camera.cameraType == "back");
        //     barcodePicker.setActiveCamera(camera);
        //     barcodePicker.accessCamera();
        //   });
        // }
        if (this.props.onScan != null) {
          barcodePicker.on('scan', this.props.onScan);
        }
        const settings = barcodePicker.getScanner().getScanSettings();
        settings.getSymbologySettings(Barcode.Symbology.CODE128).setActiveSymbolCountsRange(1, 25);
        // settings.enableSymbology(Barcode.Symbology.QR, true);
        barcodePicker.applyScanSettings(settings);
        if (this.props.onError != null) {
          barcodePicker.on('scanError', this.props.onError);
        }
      });
    });
  }


  componentWillUnmount() {
    if (this.barcodePicker != null) {
      this.barcodePicker.destroy();
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.scanSettings) !== JSON.stringify(this.props.scanSettings)) {
      this.barcodePicker.applyScanSettings(this.props.scanSettings);
    }

    if (prevProps.visible !== this.props.visible) {
      this.barcodePicker.setVisible(this.props.visible);
    }
  }

  render() {
    return <div ref={this.ref} style={style} />;
  }
}

export default BarcodePicker;
